import * as React from 'react';

interface Props {
  value: string | number,
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>, parent?: string) => void // optional if readonly? == true
  propName?: string, // optional if readonly? == true
  title: string,
  parentProp?: string,
  class?: string,
  inputType?: string,
  reference?: any,
  readonly?: boolean,
  disabled?: boolean,
}

interface State {
  value: string | number,
}

class TextInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { value: props.value }
  }

  public setFocus = () => {
    if (this.props.reference) {
      this.props.reference.current.focus();
    }
  }

  render() {
    return (
      <div className='d-flex justify-content-center'>
        <div className={`input-group col-12 ${this.props.class}`}>
          <div className="input-group-prepend ">
            <span className='input-group-text input-label' >
              {this.props.title}:
            </span>
          </div>
          <input type={this.props.inputType || "text"}
            className="form-control"
            placeholder={String(this.state.value)}
            value={this.props.value || ''}
            name={this.props.propName}
            onChange={e => this.props.handleChange ? this.props.handleChange(e, this.props.parentProp) : {}}
            ref={this.props.reference}
            readOnly={this.props.readonly}
            disabled={this.props.disabled}
          />
        </div>
      </div>
    )
  }

}



export default TextInput